import React from "react";
import PropTypes from "prop-types";

import { EditScale } from "./EditScale";
import { performUpdateRequest } from "../../../../../../actions/dataComponentActions";
import { useUpdateProcessRequests } from "../../../../../hooks/useProcessRequest";
import { scaleDataComponentId } from "../ScaleContainer";
import propTypes from "../../../../../../constants/propTypes";
import {
  connectScaleForm,
  scaleFormPropTypes,
  useScaleFormFeedback,
} from "../scaleFormWiring";

const EditScaleContainer = ({ scale, performUpdateRequest, ...props }) => {
  useScaleFormFeedback(props.dataComponent, useUpdateProcessRequests, {
    successMessage: "Scale saved successfully.",
    ...props,
  });

  const handleEditScale = values => {
    performUpdateRequest(scaleDataComponentId, scale.id, values);
  };

  return (
    <EditScale
      scale={scale}
      handleEditScale={handleEditScale}
      closeModalDialog={props.closeModalDialog}
    />
  );
};

EditScaleContainer.propTypes = {
  ...scaleFormPropTypes,
  scale: propTypes.scale.isRequired,
  performUpdateRequest: PropTypes.func.isRequired,
};

export default connectScaleForm(EditScaleContainer, { performUpdateRequest });
